/**
 * Trạng thái của form
 */
export default {
  IsLevelUp: 1,
  AddNew: 0,
  NotLevelUp: 2,
}
